module.exports = __webpack_public_path__ + "img/official-qr.08286ed0.jpg";